import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=14a55283&"
import script from "./Translations.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Translations.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports